/* eslint-disable no-shadow */
import axios from 'axios';
import download from 'downloadjs';
import { format } from 'date-fns';
import { DATA_LATENCY_TYPE, ESysInfoAction } from '../constants';
import { baseURL, myEpikBaseURL, unifiedBaseURL } from './api';

const url = require('url');

const apiVersion = 'v2';
const path = process.env.REACT_APP_BASE_URL + '/api/';

class BoxService {
  static baseURL = baseURL;

  static resourcePath = path || '';

  constructor(api, demo = false, baseURLOverride) {
    this.api = api;
    this.demo = demo;
    this.baseURL = baseURLOverride;
  }

  getBaseURL = myEpik => {
    const urlObj = url.parse(document.location.href, true);
    // const dev =
    //   urlObj.href.indexOf('my.epik.io') !== -1 ||
    //   urlObj.href.indexOf('mytest.epik.io') !== -1 ||
    //   urlObj.href.indexOf('mytestapi.epik.io') !== -1;
    const route = window.location.pathname.split('/');
    // if (!dev) {
    //   return this.baseURL || BoxService.resourcePath || BoxService.baseURL;
    // }
    if (
      myEpik ||
      (global.myEpik === 'Yes' && (route.length === 3 || route?.[1] === 'fulfillment'))
    ) {
      return myEpikBaseURL;
    }
    if (global.myEpik === 'No' && (route.length === 3 || route?.[1] === 'fulfillment')) {
      return unifiedBaseURL();
    }
    global.myEpik = 'Yes';
    return this.baseURL || BoxService.resourcePath || BoxService.baseURL;
  };
  getBaseURLMyEpik = () => {
   const myEpikBaseURL = process.env.REACT_APP_MYEPIK_URL;
    return myEpikBaseURL;
  };

  getPaginateOptions = options => {
    return JSON.stringify(options || { page: 1, limit: 10 });
  };

  getFiltersOptions = options => {
    if (options.from) {
      options.from = format(options.from, 'yyyy-MM-dd');
    }
    if (options.to) {
      options.to = format(options.to, 'yyyy-MM-dd');
    }
    return JSON.stringify(options || {});
  };

  async configurePort(configData) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const data = await axios.patch(
      `${this.getBaseURL(global.vmail)}${apiVersion}/boxes/${configData.boxId}/serviceType`,
      {
        serviceName: configData.serviceName,
        boxPortNumber: configData.boxPortNumber,
        boxId: configData.boxId,
        isBoxTab: configData.isBoxTab,
      },
      { headers },
    );
    return data;
  }

  // get boxes by company group id
  async getBoxesByGroupID(companyId, paginateOptions, getDeleted = global.deleteMode) {
    const options = this.getPaginateOptions(paginateOptions);
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/filter?type=companyGroup&value=${companyId}&paginateOptions=${options}&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  // GET /api/companies/:id/boxes/all
  async getBoxes(
    companyId,
    online,
    unmonitored,
    disablePaginate,
    paginateOptions,
    companyFilter,
    getDeleted = global.deleteMode,
  ) {
    let onlineStatus;
    if (online === undefined) {
      onlineStatus = true;
    } else {
      onlineStatus = online;
    }
    const options = this.getPaginateOptions(paginateOptions);
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${companyId}/boxes?online=${onlineStatus}&unmonitored=${unmonitored}&disablePaginate=${disablePaginate}&paginateOptions=${options}&getDeleted=${getDeleted}&companyFilter=${companyFilter}`,
      { headers },
    );
    return data;
  }

  // GET /api/companies/:id/boxes?filterOpts={"filterBy": "serialNumber"}&disablePaginate=yes
  async getEpikBoxesSerial(companyId, disablePaginate = 'yes', expansion = false) {
    const headers = { Authorization: `Bearer ${this.api.token}` };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${companyId}/boxes?filterOpts={"filterBy": "serialNumber", "expansion": ${expansion} }&disablePaginate=${disablePaginate}`,
      { headers },
    );
    return data;
  }

  async enableStarCodes(boxId, body) {
    const headers = { Authorization: `Bearer ${this.api.token}` };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxId}/enableStarCodes`,
      body,
      {
        headers,
      },
    );
    return data;
  }
  async enableBoxCallForward(boxId, boxOfflineCallForward, boxOfflineCallForwardNumber) {
    const headers = { Authorization: `Bearer ${this.api.token}` };
    const body = {boxOfflineCallForward:boxOfflineCallForward,
                  boxOfflineCallForwardNumber:boxOfflineCallForwardNumber  
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxId}/enableDisableCallForwarding`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async resetStarCodes(boxId, body) {
    const headers = { Authorization: `Bearer ${this.api.token}` };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxId}/resetStarCodes`,
      body,
      {
        headers,
      },
    );
    return data;
  }
  async getPing(vpnAddress, type) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/initiateping/${type}/${vpnAddress}`,
      { headers },
    );
    return data;
  }


  async getFetchPing(vpnAddress, type) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/fetchping/${type}/${vpnAddress}`,
      { headers },
    );
    return data;


  }

  // GET /api/locations/:id/boxes/
  async getBoxesByLocation(locationId, companyId, paginateOptions) {
    const options = this.getPaginateOptions(paginateOptions);
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/locations/${locationId}/boxes?company=${companyId}&paginateOptions=${options}`,
      { headers },
    );
    return data;
  }

  async getBoxCount(companyId, getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${companyId}/boxes/count?getDeleted=${getDeleted}`,
      {
        headers,
      },
    );
    return data;
  }

  async addNote(id, obj) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(`${this.getBaseURL()}${apiVersion}/boxes/${id}/notes`, obj, {
      headers,
    });
    return data;
  }

  async postReleaseNote(obj) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(`${this.getBaseURL()}${apiVersion}/releaseNotes`, obj, {
      headers,
    });
    return data;
  }

  async latestReleaseNote() {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/releaseNotes/latest`, {
      headers,
    });
    return data;
  }

  async setReleaseNoteSeen() {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/releaseNotes/seen`, {
      headers,
    });
    return data;
  }

  async getMaintenanceNotes() {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/releaseNotes/maintenance`, {
      headers,
    });
    return data;
  }

  async getReleaseNotes() {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/releaseNotes`, {
      headers,
    });
    return data;
  }

  async updateReleaseNotes(noteID, payload) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/releaseNotes/${noteID}`,
      payload,
      {
        headers,
      },
    );
    return data;
  }

  async deleteReleaseNotes(noteID) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.delete(
      `${this.getBaseURL()}${apiVersion}/releaseNotes/${noteID}`,
      {
        headers,
      },
    );

    return data;
  }

  async addUnAuthNote(id, obj) {
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/boxes/notes?boxId=${id}`,
      obj,
    );
    return data;
  }

  async getNotes(id, pagination) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(pagination);
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${id}/notes?paginateOptions=${options}`,
      {
        headers,
      },
    );
    return data;
  }

  async getFilterNotes(id, queryFilter, pagination, sort) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(pagination);
    const queryParams = JSON.stringify(queryFilter);
    const sortOptions = JSON.stringify(sort);
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${id}/notes?queryFilter=${queryParams}&paginateOptions=${options}&sort=${sortOptions}`,
      {
        headers,
      },
    );
    return data;
  }

  async enhancedRouting(bid, toggle, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const tValue = toggle ? 1 : 0;
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/advanced-routing/configure?toggle=${tValue}`, body,
      {
        headers,
      },
    );
    return data;
  }

  async changeBoxRegistrar(bid, toggle) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const tValue = toggle ? 1 : 0;
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/boxRegistrar?toggle=${tValue}`,
      {
        headers,
      },
    );
    return data;
  }

  async onDeleteRecording(noteId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.delete(
      `${this.getBaseURL()}${apiVersion}/boxes/notes/${noteId}/attachment`,
      {
        headers,
      },
    );
    return data;
  }

  async getLogs(boxid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxid}/auditTrail`,
      {
        headers,
      },
    );
    return data;
  }

  async editNote(box_id, note, note_id) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/${box_id}/notes/${note_id}`,
      note,
      {
        headers,
      },
    );
    return data;
  }

  async deleteNote(box_id, note_id) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.delete(
      `${this.getBaseURL()}${apiVersion}/boxes/${box_id}/notes/${note_id}`,
      {
        headers,
      },
    );
    return data;
  }

  async analyzeRecording(note_id) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/notes/${note_id}/analyze`,
      {
        headers,
      },
    );
    return data;
  }
  async downloadAttachment(note_id, fileName, noDownload) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/notes/${note_id}/download`,
      {
        headers,
        responseType: 'blob',
      },
    );
    if (noDownload) return data;
    download(data, fileName, data.type);
  }

  // async getAllBoxes() {
  //   const headers = {
  //     Authorization: `Bearer ${this.api.token}`,
  //   };
  //   const { data } = await axios.get(
  //     `${this.getBaseURL()}${apiVersion}/boxes/boxNames`,
  //     { headers },
  //   );
  //   return data;
  // }

  async getEpikBoxesDataByObi(
    obiNumber,
    online = 'none',
    paginateOptions,
    getDeleted = global.deleteMode,
  ) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/filter?type=obinumber&value=${obiNumber}&online=${online}&paginateOptions=${options}&getDeleted=${getDeleted}`,
      {
        headers,
      },
    );
    return data;
  }

  async getEpikUnassignedBoxesData() {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/boxes/unassigned`, {
      headers,
    });
    return data;
  }

  async getEpikBoxesByStatus(
    status,
    online = 'none',
    paginateOptions,
    getDeleted = global.deleteMode,
  ) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/filter?type=status&value=${status.toLowerCase()}&online=${online}&paginateOptions=${options}&getDeleted=${getDeleted}`,
      {
        headers,
      },
    );
    return data;
  }

  async getEpikBoxesBySerialNumber(
    serialNumber,
    online = 'none',
    paginateOptions,
    getDeleted = global.deleteMode,
  ) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/filter?type=serialNumber&value=${serialNumber}&online=${online}&paginateOptions=${options}&getDeleted=${getDeleted}`,
      {
        headers,
      },
    );
    return data;
  }

  async getEpikBoxesByFavorites(
    paginateOptions,
    getDeleted = global.deleteMode,
  ) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL(true)}${apiVersion}/boxes/filter?type=favorites&paginateOptions=${options}&getDeleted=${getDeleted}`,
      {
        headers,
      },
    );
    return data;
  }


  async getEpikBoxesByAssingedNumber(
    assignedNumber,
    online = 'none',
    paginateOptions,
    getDeleted = global.deleteMode,
  ) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/filter?type=assignedNumber&value=${encodeURIComponent(
        assignedNumber,
      )}&online=${online}&paginateOptions=${options}&getDeleted=${getDeleted}`,
      {
        headers,
      },
    );
    return data;
  }

  async getEpikBoxesByTrackingNumber(
    trackingNumber,
    online = 'none',
    paginateOptions,
    getDeleted = global.deleteMode,
  ) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/filter?type=trackingNumber&value=${encodeURIComponent(
        trackingNumber,
      )}&online=${online}&paginateOptions=${options}&getDeleted=${getDeleted}`,
      {
        headers,
      },
    );
    return data;
  }

  async getEpikBoxesDataByName(
    boxName,
    online = true,
    paginateOptions,
    getDeleted = global.deleteMode,
  ) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/filter?type=boxname&value=${encodeURIComponent(
        boxName,
      )}&online=${online}&paginateOptions=${options}&getDeleted=${getDeleted}`,
      {
        headers,
      },
    );
    return data;
  }

  async getEpikBoxesByAdSearch(params, paginateOptions) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/enhancedSearchFilter?${params}&paginateOptions=${options}`,
      {
        headers,
      },
    );
    return data;
  }

  async getEpikBoxesByVPNAddress(vpnaddress, paginateOptions, getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/filter?type=vpnAddress&value=${encodeURIComponent(
        vpnaddress,
      )}&paginateOptions=${options}&getDeleted=${getDeleted}`,
      {
        headers,
      },
    );
    return data;
  }

  async bulkAssignEpikBox(payload) {
    const headers = { Authorization: `Bearer ${this.api.token}` };

    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/boxes/bulkAssign`,
      payload,
      { headers },
    );
    return data;
  }

  async getEpikBoxesByMacAddress(
    macAddress,
    online = 'none',
    paginateOptions,
    getDeleted = global.deleteMode,
  ) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/filter?type=obiMac&value=${macAddress}&online=${online}&paginateOptions=${options}&getDeleted=${getDeleted}`,
      {
        headers,
      },
    );
    return data;
  }

  async getEpikBoxesByIMEI(imei, online = 'none', paginateOptions, getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/filter?type=imei&value=${imei}&online=${online}&paginateOptions=${options}&getDeleted=${getDeleted}`,
      {
        headers,
      },
    );
    return data;
  }

  async getEpikBoxesBySIM(sim, online = 'none', paginateOptions, getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/filter?type=sim&value=${sim}&online=${online}&paginateOptions=${options}&getDeleted=${getDeleted}`,
      {
        headers,
      },
    );
    return data;
  }

  async getEpikBoxesByCreated(created, online = 'none', paginateOptions, getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(paginateOptions);
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/filter?type=created&value=${created}&online=${online}&paginateOptions=${options}&getDeleted=${getDeleted}`,
      {
        headers,
      },
    );
    return data;
  }

  async getActiveInterface(boxId, vpnAddress) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxId}/activeInterface?vpnAddress=${vpnAddress}`,
      {
        headers,
      },
    );
    return data;
  }

  // GET /api/v2/boxes/
  async getBoxDetail(box, getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${box._id}?getDeleted=${getDeleted}`,
      {
        headers,
      },
    );
    return data;
  }

  async getLocationByCompany(companyId, getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${companyId}/locations?getDeleted=${getDeleted}`,
      {
        headers,
      },
    );
    return data;
  }

  async onRemoveLocation(id) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.delete(`${this.getBaseURL()}${apiVersion}/locations/${id}`, {
      headers,
    });
    return data;
  }

  async boxConfig(currBox, selectedBox, isExpansionModule) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL(false)}${apiVersion}/boxes/${currBox}/blankConfig?targetBoxSerial=${selectedBox}&isExpansionModule=${isExpansionModule}`,
      {
        headers,
      },
    );
    return data;
  }

  async swapBoxObi(currBox, selectedBox, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/obis/swap?currentBox=${currBox}&targetBox=${selectedBox}`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async getSwapStatus(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxId}/swap-status`,
      { headers },
    );
    return data;
  }

  async onAddNewLocation(companyId, location, getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    location.company = companyId;
    location.locationName = location.address.name;
    location.locationId = location.address.locationId;
    location.geoJson = { coordinates: [location.address.lng, location.address.lat] };

    delete location.address.name;
    delete location.address.locationId;
    delete location.address.lng;
    delete location.address.lat;
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/companies/${companyId}/locations?getDeleted=${getDeleted}`,
      location,
      {
        headers,
      },
    );
    return data;
  }

  async onUpdateLocation(id, location, getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    location.locationName = location.address.name;
    location.locationId = location.address.locationId;
    location.company = id;
    location.geoJson = { coordinates: [location.address.lng, location.address.lat] };

    delete location.address.name;
    delete location.address.locationId;
    delete location.address.lng;
    delete location.address.lat;
    const lid = location.address._id;
    if (!lid) throw new Error('Invalid location ID');
    delete location.address._id;

    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/locations/${lid}?getDeleted=${getDeleted}`,
      location,
      {
        headers,
      },
    );
    return data;
  }

  async getNumbers(companyId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${companyId}/numbers?type=phone`,
      {
        headers,
      },
    );
    return data;
  }

  async getAssignedNumbers(cid, uid, priStatus) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const path = `/companies/${cid}/numbers`;
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}${path}?disablePaginate=yes&epikBoxUser=${uid}&type=none&pri=${priStatus}`,
      {
        headers,
      },
    );

    return data;
  }

  // eslint-disable-next-line class-methods-use-this
  async getSpeedTestInformation(serialNumber) {
    const urlObj = url.parse(document.location.href, true);
    const dev = urlObj.href.indexOf('fsdev.epik.io') !== -1;
    // console.log(':: fsdev check ::', dev);
    const fsdevUrl = 'http://fsdev.epik.io:3000/api/';
    const baseUrl = dev ? fsdevUrl : myEpikBaseURL;
    const path = `/boxes/speedTest`;
    const { data } = await axios.get(`${baseUrl}${apiVersion}${path}?serialNum=${serialNumber}`);
    return data;
  }

  async getLteAnalyzer(bid, vpnAddress) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/lteAnalyzer?vpnAddress=${vpnAddress}`,
      {
        headers,
      },
    );

    return data;
  }

  async getEngineeringLock(bid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL(true)}${apiVersion}/engineering-lock/${bid}/detail`,
      {
        headers,
      },
    );

    return data;
  }
  async addEngineeringLock(bid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL(true)}${apiVersion}/engineering-lock/${bid}/detail`,
      { boxId: bid },
      {
        headers,
      },
    );

    return data;
  }
  async deleteEngineeringLock(bid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.delete(
      `${this.getBaseURL(true)}${apiVersion}/engineering-lock/${bid}/detail`,
      {
        headers,
      },
    );

    return data;
  }

  async getAdminFlags(bid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/admin-flags`,
      {
        headers,
      },
    );

    return data;
  }

  async getPortCallHistory(bid, portNumber) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const path = `/boxes/callHistory`;
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}${path}?boxId=${bid}&port=${portNumber}`,
      {
        headers,
      },
    );

    return data;
  }

  async onRemoveAtaNumber(ataNumber, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const path = `/ata`;
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}${path}/${ataNumber}/unassignNumber`,
      body,
      {
        headers,
      },
    );

    return data;
  }

  async onMonitorAtaNumber(ataNumber, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const path = `/ata`;
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}${path}/${ataNumber}/updatePort`,
      body,
      {
        headers,
      },
    );

    return data;
  }

  async getObiSystemStatus(bid, portNumber) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const path = `/boxes/${bid}/obiSystemStatus`;
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}${path}?port=${portNumber}`,
      {
        headers,
      },
    );

    return data;
  }

  async getPortsRegStatus(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const path = `/boxes/${boxId}/portsRegStatus`;
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}${path}`,
      {
        headers,
      },
    );

    return data;
  }

  async getPhysicalStatus(bid, portNumber) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const path = `/obis/${bid}/physicalStatus`;
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}${path}?port=${portNumber}`,
      {
        headers,
      },
    );

    return data;
  }

  async getSimStatus(body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(`${this.getBaseURL()}${apiVersion}/sim`, body, {
      headers,
    });
    return data;
  }


  async pingSim(ip) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/utils/ping/?ip=${ip}`, {
      headers,
    });
    return data;
  }

  async getUpDownSpeedInformation(serialNumber, type) {
    const urlObj = url.parse(document.location.href, true);
    const dev = urlObj.href.indexOf('fsdev.epik.io') !== -1;
    // console.log(':: fsdev check ::', dev);
    const fsdevUrl = 'http://fsdev.epik.io:3000/api/';
    const baseUrl = dev ? fsdevUrl : myEpikBaseURL;
    const path = `/boxes/speedTest`;
    const { data } = await axios.get(
      `${baseUrl}${apiVersion}${path}?serialNum=${serialNumber}&type=${type}`,
    );
    return data;
  }

  async setAssignedNumbers(bid, assignedNumberList) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const path = `/boxes/${bid}/pri`;

    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}${path}/assign`,
      assignedNumberList,
      {
        headers,
      },
    );

    return data;
  }

  async filterAssignedNumber(number, bid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const path = `/numbers/autoComplete`;
    const filterAssignedNumber = '';
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}${path}?priNumber=${number}&boxCompany=${bid}`,
      {
        headers,
      },
    );

    return data;
  }

  async setImportNumbers(list) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const path = `/numbers`;
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}${path}?isPriNum=true&bulkInsert=true`,
      list,
      {
        headers,
      },
    );

    return data;
  }

  async insertPhone(boxId, obj) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(`${this.getBaseURL()}${apiVersion}/phones/${boxId}`, obj, {
      headers,
    });
    return data;
  }

  async updatePhone(phoneId, obj) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(`${this.getBaseURL()}${apiVersion}/phones/${phoneId}`, obj, {
      headers,
    });
    return data;
  }

  async deletePhone(phoneId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.delete(`${this.getBaseURL()}${apiVersion}/phones/${phoneId}`, {
      headers,
    });
    return data;
  }

  async getBoxesDetail(companyId, paginateOptions, getDeleted = global.deleteMode) {
    const options = this.getPaginateOptions(paginateOptions);
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    if (companyId === undefined) {
      const { data } = await axios.get(
        `${this.getBaseURL()}${apiVersion}/boxes?paginateOptions=${options}&getDeleted=${getDeleted}`,
        { headers },
      );
      return data;
    }
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${companyId}/boxes?paginateOptions=${options}&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  async getPopulateBoxes(companyId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${companyId}/populate-boxes`,
      { headers },
    );
    return data;
  }

  async getEpikBoxLocations(getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/locations/boxes?getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  async mapLocationsFilter(type, value, getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/locations/boxes/filter?type=${type}&value=${value}&getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  async getBox(boxId, getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxId}?getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }
  async getLiveCallFeature(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/obis/${boxId}/CallFeature/Ports`,
      { headers },
    );
    return data;
  }

  async getCurrentAtaVersions(vpnAddress) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/obis/${vpnAddress}/currentAtaVersions`,
      { headers },
    );
    return data;
  }

  async getSignalStrength(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxId}/ltesignalstrength`,
      { headers },
    );
    return data;
  }

  // getDCData
  async getDCData() {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/boxes/getBoxesDetail`, {
      headers,
    });
    return data;
  }

  async getBoxPower(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxId}/getPowerState?getPowerStateOnly=true`,
      { headers },
    );
    return data;
  }

  async getRestStatus(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${unifiedBaseURL()}${apiVersion}/boxes/${boxId}/restStatus`,
      {},
      { headers },
    );
    return data;
  }
  async getBoxCarrier(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${unifiedBaseURL()}${apiVersion}/boxes/${boxId}/getCarrierInfo`,
      { headers },
    );
    return data;
  }
  async updateNumberRouteAndTrunk(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/update-number-route-and-trunk/${boxId}`,
      {},
      { headers },
    );
    return data;
  }
  async checkNumberRouteAndTrunk(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/check-number-route-and-trunk/${boxId}`,
      {},
      { headers },
    );
    return data;
  }

  async getSysInfo(boxId, getDeleted = global.deleteMode, type = ESysInfoAction.OLD) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${unifiedBaseURL()}${apiVersion}/boxes/${boxId}/${type}?getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  async inititateSysInfo(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${unifiedBaseURL()}${apiVersion}/boxes/${boxId}/initiateSysInfoPing`,
      { headers },
    );
    return data;
  }

  async createBox(box) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const box_ = {
      ...box,
      isBoxTab: false,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/companies/${box.assignedTo}/boxes`,
      box_,
      { headers },
    );
    return data;
  }

  // PUT api/v2/obis/trunkPortConfig
  async trunkPortConfig(body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/obis/trunkPortConfig`,
      body,
      { headers },
    );
    return data;
  }

  // PUT  api/v2/boxes/boxId/forward
  async boundForwardNumber(bid, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/forward`,
      body,
      { headers },
    );
    return data;
  }

  async alarmProtocolToggle(bid, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/alarm-relay/box/${bid}/toggle`,
      body,
      { headers },
    );
    return data;
  }

  async initiateAlarmTest(bid, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/alarm-relay/box/${bid}/createTimer`,
      body,
      { headers },
    );
    return data;
  }

  async getAlarmTest(bid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/alarm-relay/box/${bid}/getAlarmRelayTimer`,
      { headers },
    );
    return data;
  }

  async updateAlarmTest(bid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/alarm-relay/box/${bid}/updateTimer`,
      { headers },
    );
    return data;
  }

  async fetchAlarmResult(bid, nid, obiId, portNumber) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/alarm-relay/box/${bid}/number/${nid}/fetchResults?obiID=${obiId}&portNumber=${portNumber}`,
      { headers },
    );
    return data;
  }

  async updateAlarmProtocol(bid, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/alarm-relay/box/${bid}/updateAlarmRelay`,
      body,
      { headers },
    );
    return data;
  }

  // PUT api/v2/boxes/boxId/removeForward
  async boundRemoveNumber(bid, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/removeForward`,
      body,
      { headers },
    );
    return data;
  }

  // PUT api/v2/obis/:id/disableVM
  async unassingVmailNumber(obiId, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL(true)}${apiVersion}/obis/${obiId}/disableVM`,
      body,
      { headers },
    );
    return data;
  }

  async getSystemStatus(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxId}/systemStatus`,
      { headers },
    );
    return data;
  }

  async updateBox(box,expansionEnable) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    if (box.assignedTo) {
      box.assignedTo = box.assignedTo._id || box.assignedTo;
    }
    if (box.locRef && Object.keys(box.locRef).length === 0) {
      box.locRef = null;
    }
    if (box.newBox) {
      box.isBoxTab = false;
    }
    const query = expansionEnable ? `?expansionEnable=${expansionEnable}` : '';
    const { data } = await axios.put(`${this.getBaseURL()}${apiVersion}/boxes/${box._id}${query}`, box, {
      headers,
    });

    return data;
  }

  async updateInterCalling(boxId, status) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxId}/box-international-calling`,
      status,
      { headers },
    );

    return data;
  }

  async activateEpikBox(bid, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/registration`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async boxLockStatus(bid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/boxSessions/${bid}`, {
      headers,
    });
    return data;
  }

  async eSIMStatus(bid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${unifiedBaseURL()}${apiVersion}/boxes/${bid}/simStatus`, {
      headers,
    });
    return data;
  }

  async getPrimarySim(bid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${unifiedBaseURL()}${apiVersion}/boxes/${bid}/getPrimarySim`, {
      headers,
    });
    return data;
  }

  async setPrimarySim(status, bid, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data }  = await axios.post(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/setPrimarySim/${status}`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async addLockTime(bid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxSessions/${bid}/updateLock`,
      {
        headers,
      },
    );
    return data;
  }

  async addSipInfo(body) {
    // const headers = {
    //   Authorization: `Bearer ${this.api.token}`,
    // };
    // const { data } = await axios.get(
    //   `${this.getBaseURL()}${apiVersion}/`,
    //   {
    //     headers,
    //   },
    // );
    // return data;
    return true;
  }

  async addSipSaveInfo(body) {
    // const headers = {
    //   Authorization: `Bearer ${this.api.token}`,
    // };
    // const { data } = await axios.get(
    //   `${this.getBaseURL()}${apiVersion}/`,
    //   {
    //     headers,
    //   },
    // );
    // return data;
    return true;
  }

  async releaseLock(bid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxSessions/${bid}/releaseLock`,
      {
        headers,
      },
    );
    return data;
  }

  async overrideLock(bid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxSessions/${bid}/overrideLockByRole`,
      {
        headers,
      },
    );
    return data;
  }
  async getSipPri(bid, ispri) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/pri-sip/numbers?ispri=${ispri}`,
      {
        headers,
      },
    );
    return data;
  }

  async updateSipPri(bid, ispri, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/assign/pri-sip/numbers?ispri=${ispri}`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async getPriStatus(vpnAddress) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${vpnAddress}/priStatusCheck`,
      {
        headers,
      },
    );
    return data;
  }

  async boxLock(bid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxSessions/${bid}/addLock`,
      {
        headers,
      },
    );
    return data;
  }

  async getPortList(bid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/portForwardList`,
      {
        headers,
      },
    );
    return data;
  }

  async portForward(bid, obj) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/portForward`,
      obj,
      {
        headers,
      },
    );
    return data;
  }

  async updatePortForward(bid, index, obj) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/portForward/${index}`,
      obj,
      {
        headers,
      },
    );
    return data;
  }

  async getWifiStatus(vpn) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/checkWifiStatus/${vpn}`,
      {},
      {
        headers,
      },
    );
    return data;
  }

  async disableWifi(vpn, obj) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/disableWifi/${vpn}`,
      obj,
      {
        headers,
      },
    );
    return data;
  }

  async enableWifi(vpn, obj) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/enableWifi/${vpn}`,
      obj,
      {
        headers,
      },
    );
    return data;
  }

  async addBoxAction(bid, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/boxSessions/${bid}/addActions`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async activateE2(bid, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/activateE2`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async deactivateE2(bid, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/deactivateE2`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async activateE3(bid, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/activateE3`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async deactivateE3(bid, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/deactivateE3`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async getDhcp(vpn) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/dhcp/eth1?vpnAddress=${vpn}`,
      {
        headers,
      },
    );
    return data;
  }

  async getNetworkConnectivatyStatus(bid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/boxes/${bid}/networkInfo`, {
      headers,
    });
    return data;
  }

  async disableDHCP(vpn, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/boxes/dhcp/eth1?vpnAddress=${vpn}&status=disable`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async enableDHCP(vpn, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/boxes/dhcp/eth1?vpnAddress=${vpn}&status=enable`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async setInterfacePriority(vpn, value, body,payload) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/boxes/ispPriority/${vpn}?priority=${encodeURIComponent(
        value,
      )}`,
      {
        ...payload, 
        ...body
      },
      {
        headers,
      },
    );
    return data;
  }

  async boxHardReset(object, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/hard-reset/${object?.vpn}`,
      body,
      {
        headers,
        cancelToken: object?.source?.token,
      },
    );
    return data;
  }

  async getInterfacePriority(vpn) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/boxes/ispPriority/${vpn}`, {
      headers,
    });
    return data;
  }
  async getInterfacePriorityIsp(vpn) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/boxes/ispPriorityIsp/${vpn}`, {
      headers,
    });
    return data;
  }

  async setCarrier(vpn, value) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/boxes/apn/${vpn}?carrier=${value.carrier}`,
      {
        apn: value.apn,
        isBoxTab: value.isBoxTab,
        boxId: value.boxId,
      },
      {
        headers,
      },
    );
    return data;
  }

  async getCarrier(vpn, carrier) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/apn/${vpn}?carrier=${carrier}`,
      {
        headers,
      },
    );
    return data;
  }

  async getCurrentApn(vpn) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/boxes/current-apn/${vpn}`, {
      headers,
    });
    return data;
  }

  async sipPriDiagnosticsPort(object) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const url = object?.channelId
      ? `type=${object?.type}&channelId=${object?.channelId}`
      : `type=${object?.type}`;

    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${object?.id}/sip-pri-diagnostic?isPri=${object?.isPri
      }&${url}`,
      {
        headers,
      },
    );
    return data;
  }

  async isUpdateRequired(id) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${id}/updateRequired`,
      {
        headers,
      },
    );
    return data;
  }

  async rebootEpikBox(obj, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/${obj?.bid}/reset`,
      body,
      {
        headers,
        cancelToken: obj?.source?.token,
      },
    );
    return data;
  }

  async rebootObi(deviceId, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/obis/reboot/${deviceId}`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async failoverInstall(bid, vpn) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/failover/install?vpn=${vpn}`,
      {
        headers,
      },
    );
    return data;
  }

  async applyUpdateEpikBox(bid, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/updateFirmware`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async convertBoxDid(bid, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/convert-box-temp-did`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async getVoicePorts(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/boxes/${boxId}/huntPorts`, {
      headers,
    });
    // return ['Port 1', 'Port 5', 'Port 6', 'Port 7', 'Port 8'];
    return data;
  }
  async getEligibleBoxToBoxHunt(parentBoxId, params = {}) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const {
      huntPorts = [],
      type = 'hunt',
      page = 1,
      limit = 5,
      search = '',
      numberId,
    } = params;
    const query = new URLSearchParams({
      type,
      page: String(page),
      limit: String(limit),
      huntPorts: Array.isArray(huntPorts) ? huntPorts.join(',') : huntPorts,
    });
    if (search) query.set('search', search);
    if (numberId) query.set('numberId', String(numberId));
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${parentBoxId}/box-to-box-hunt/eligible?${query.toString()}`,
      { headers },
    );
    return data;
  }
  async getModemPorts(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/boxes/${boxId}/modemPorts`, {
      headers,
    });
    return data;
  }
  async getFaxHuntPorts(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/boxes/${boxId}/faxHuntPorts`, {
      headers,
    });
    return data;
  }

  async getAllPortsName(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxId}/port-names`,
      {
        headers,
      },
    );
    // return ['Port 1', 'Port 5', 'Port 6', 'Port 7', 'Port 8'];
    return data;
  }

  async reloadEpiInfo(box_id, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/obis/reload?boxId=${box_id}`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async rebootBox(boxid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/boxes/${boxid}/reset`, {
      headers,
    });

    return data;
  }

  async enableRecording(bid, body, recordingDuration) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/enableRecording/${recordingDuration}`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async disableRecording(bid, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/disableRecording`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async onRecover(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const data = await axios.patch(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxId}`,
      {
        deleted: false,
        isBoxTab: true,
      },
      { headers },
    );
    return data;
  }

  async updateObi(obi, epikboxUser = '', numId = '') {
    if (!obi || !obi._id) {
      throw new Error('Cannot update obi. No EPI specified');
    }
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    if (numId === null) {
      numId = '';
    }
    const { data } = await axios.put(
      `${this.getBaseURL(global.vmail)}${apiVersion}/obis/${obi._id
      }?epikBoxUser=${epikboxUser}&numId=${numId}`,
      obi,
      {
        headers,
      },
    );
    return data;
  }
  async updateNumbers(obi, epikboxUser = '', numId = '', fieldToUpdate, value) {
    if (!obi || !obi._id) {
      throw new Error('Cannot update numbers. No EPI specified');
    }
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
  
    const requestBody = {
      epikBoxUser: epikboxUser || null,
      numId: numId || null,
      fieldToUpdate,
      value,
    };
  
    const { data } = await axios.put(
      `${this.getBaseURL(global.vmail)}${apiVersion}/numbers/${obi._id}/update`,
      requestBody,
      { headers }
    );
    return data;
  }
  


  async portConfig(body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/obis/e911PortConfig`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async getPortValues(obiId, values) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/obis/${obiId}/portValues?values=${values}`,
      {
        headers,
      },
    );
    return data;
  }

  async setPortValues(obiId, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/obis/${obiId}/portValues`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async setSilenceDetect(obiId, portNum, toggle) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/obis/${obiId}/sds/${portNum}/${toggle}`,
      {
        headers,
      },
    );
    return data;
  }

  async unCheckPri(bid, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/pri/uncheck`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async advancedMonitoring(body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/boxes/advancedMonitoring`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async unassignNumber(number = '', body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/obis/unassignNumber/${number}`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  // async onUploadPortConfig(obi, file) {
  //   console.log("file recieved :: ", file);
  //   if (!obi || !obi._id) {
  //     throw new Error('Cannot update obi. No EPI specified');
  //   }
  //   const headers = {
  //     Authorization: `Bearer ${this.api.token}`,
  //   };
  //   const { data } = await axios.post(`${this.getBaseURL()}obis/${obi._id}/configure`, { "config": file }, {
  //     headers,
  //   });
  //   console.log("data onUploadPortConfig :: ", data);

  //   return data;
  // }

  async getBoxObis(boxId, companyId, getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/companies/${companyId}/boxes/${boxId}/obis?getDeleted=${getDeleted}`,
      { headers },
    );
    return data;
  }

  async getUnassignedObis(paginateOptions, searchString, getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    if (!searchString) {
      const { data } = await axios.get(
        `${this.getBaseURL()}v2/obis?paginateOptions=${JSON.stringify(
          paginateOptions,
        )}&getDeleted=${getDeleted}`,
        { headers },
      );
      return data;
    }
    const { data } = await axios.get(
      `${this.getBaseURL()}v2/obis/allByMacs/${searchString}?paginateOptions=${JSON.stringify(
        paginateOptions,
      )}`,
      { headers },
    );
    return data;
  }

  async assignToBox(obiId, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/obis/${obiId}/assign`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async assignAta(body, bid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/ata/box/${bid}/assign`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async unAssignAta(body, externalId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/ata/${externalId}/unassign`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async uploadConfig(obi, jsonObj) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/advancedValues/${obi.deviceId}`,
      jsonObj,
      {
        headers,
      },
    );
    return data;
  }

  async downloadConfig(epi) {
    if (!epi) {
      throw new Error('Cannot download config file. Unspecified EPI');
    }
    const res = await fetch(
      `http://prov.epikadmin.com:3030/api/provision/xml/${epi.macAddress}.cfg`,
    );
    const blob = await res.blob();
    download(blob, `${epi._id}-config.json`, 'application/json');
  }

  async deleteBox(box, hardDelete = global.deleteMode ? 'yes' : 'no') {
    if (!box) {
      throw new Error('Cannot delete Edge Device. Unspecified Edge Device');
    }
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.delete(
      `${this.getBaseURL()}${apiVersion}/boxes/${box._id}?hardDelete=${hardDelete}`,
      {
        headers,
      },
    );
    return data;
  }

  async obiRebootRequired(obiId, payload) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const data = await axios.patch(`${this.getBaseURL()}${apiVersion}/obis/${obiId}`, payload, {
      headers,
    });
    return data;
  }

  async deleteBoxEpi(obi, hardDelete = global.deleteMode ? 'yes' : 'no') {
    if (!obi._id) {
      throw new Error('Cannot Delete EPI. Unspecified EPI');
    }
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/obis/${obi._id}/unassign?hardDelete=${hardDelete}`,
      obi,
      { headers },
    );
    return data;
  }

  async populateEpis(getDeleted = global.deleteMode) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/obis/populate?getDeleted=${getDeleted}`,
      {
        headers,
      },
    );
    return data;
  }

  async importEpikBox(number) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/sheets?serialNum=${number}`,
      { headers },
    );
    return data;
  }

  async logBoxSession(body, bid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/boxSessions/${bid}/addActions`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async systemLogs(paginateOptions, filters) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/boxSessions/sytemLogs/search`,
      { paginateOptions, filters },
      {
        headers,
      },
    );
    return data;
  }

  async addSystemLogs(body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL(true)}${apiVersion}/boxSessions/sytemLogs`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async oobLogs(pagination) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(pagination);
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxSessions/sytemLogs?paginateOptions=${options}`,
      {
        headers,
      },
    );
    return data;
  }
  async secondaryTunnelStatus(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxId}/secondarytunnel/status`,
      {
        headers,
      },
    );
    return data;
  }

  async secondaryTunnel(boxId, status, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxId}/secondarytunnel/${status ? 'disable' : 'enable'
      }`,
      body,
      {
        headers,
      },
    );
    return data;
  }

  async getFirmwareVersion(bid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/firmwareVersion`,
      {
        headers,
      },
    );
    return data;
  }

  async getPublicIP(vpnAddress) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/publicIP?vpnAddress=${vpnAddress}`,
      {
        headers,
      },
    );
    return data;
  }

  async getLanIP(vpnAddress) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/lanIP?vpnAddress=${vpnAddress}`,
      {
        headers,
      },
    );
    return data;
  }

  async systemLogBox(paginateOptions, filters) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/boxSessions/search`,
      { paginateOptions, filters },
      {
        headers,
      },
    );

    return data;
  }

  async dashboardMonitoring(pagination, filter) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const options = this.getPaginateOptions(pagination);
    const path = !!filter
      ? `filterParams=${filter}&paginateOptions=${options}`
      : `paginateOptions=${options}`;
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/obis/alerts?${path}`, {
      headers,
    });
    return data;
  }

  async getSimCheckUtilities(boxId, vpnAddress) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxId}/simcheck?vpnAddress=${vpnAddress}`,
      {
        headers,
      },
    );

    return data || {};
  }

  async updateFavoriteBox(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(`${this.getBaseURL(true)}${apiVersion}/users/favoriteBoxes`,
      { boxId },
      {
        headers,
      });
    return data;
  }

  async deleteFavoriteBox(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(`${this.getBaseURL(true)}${apiVersion}/users/favoriteBoxes`,
      { boxId },
      {
        headers,
      });
    return data;
  }


  async runSimCheck(boxId, vpnAddress, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxId}/simcheck?vpnAddress=${vpnAddress}`,
      body,
      {
        headers,
      },
    );

    return data || {};
  }
  async updateBoxModelNumber(vpnAddress, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/boxes/updateBoxModelNumber?vpnAddress=${vpnAddress}`,
      body,
      {
        headers,
      },
    );

    return data;
  }
  async getBoxConnectedUsbs(boxId, vpnAddress, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxId}/connectedusbs?vpnAddress=${vpnAddress}`,
      body,
      {
        headers,
      },
    );

    return data || {};
  }

  async runSimActivationCheck(body) {
      const headers = {
        Authorization: `Bearer ${this.api.token}`,
      };
      const { data } = await axios.post(`${this.getBaseURL()}${apiVersion}/sim`, body, { headers });
      return data || [];
  }
  async fetchDataCenterLatency(boxId, type = DATA_LATENCY_TYPE.GET_LATENCY) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxId}/dc-latency?type=${type}`,
      {
        headers,
      },
    );
    return data || {};
  }

  async enableDisablePort(boxId, obiId, port, mode, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
      'Content-Type': 'application/json',
    };
    const URL = `${this.getBaseURL()}${apiVersion}/obis/${obiId}/enableDisablePort?port=${port}&mode=${mode}`;

    const { data } = await axios.patch(URL, body, {
      headers,
    });
    return data || {};
  }

  async resetBoxToDefaultService(boxID, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const URL = `${this.getBaseURL()}${apiVersion}/boxes/${boxID}/reset-box-to-default`;
    const { data } = await axios.patch(URL, body, {
      headers,
    });
    return data;
  }

  async fetchDiagnosticReport(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxId}/diagnostics`,
      {
        headers,
      },
    );
    return data || {};
  }
  async downloadRecMenulogsService(boxId, command) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const commandParam = command ? `?command=${encodeURIComponent(command)}` : '';
    try {
      const data = await axios.get(
        `${this.getBaseURL()}${apiVersion}/boxes/downloadlogfile/${boxId}${commandParam}`,
        {
          headers,
          responseType: 'blob'
        }
      );
      return data || {};
    } catch (error) {
        return null;
    }
  }

  

  async refreshDiagnosticResults(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/boxes/${boxId}/trigger`, {
      headers,
    });
    return data || {};
  }

  async checkWatchguardIsActive(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/boxes/${boxId}/is-active`, {
      headers,
    });
    return data || {};
  }

  async restartWatchguard(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/boxes/${boxId}/restart`, {
      headers,
    });
    return data || {};
  }

  async removeAlarmProtocolSettings(token, boxId, payload) {
    const headers = {
      Authorization: `Bearer ${token || this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/alarm-relay/box/${boxId}/removeAprSettings`,
      payload,
      {
        headers,
      },
    );
    return data || {};
  }

  async portChecklist(bid, portType, portNumber) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${bid}/checklist?portType=${portType}&port=${portNumber}`,
      {
        headers,
      },
    );
    return data;
  }

  async saveCheckList(bid, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL(global.vmail)}${apiVersion}/boxes/${bid}/addChecklist`,
      body,
      { headers },
    );
    return data;
  }

  async getBoxVtelCdrs(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/boxes/${boxId}/cdrs`, {
      headers,
    });
    return data || {};
  }

  async getBoxVoipmonActivity(boxID, payload) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURLMyEpik()}${apiVersion}/boxes/${boxID}/voipmonlog`,
      payload,
      {
        headers,
      },
    );
    return data || {};
  }

  async getAnalayticsImage(boxId, callID,dataCenter) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/pcap/${boxId}/svg/${callID}?dataCenter=${dataCenter}`,
      {
        headers,
      },
    );
    return data || {};
  }

  async downloadAnalayticsFile(boxId, callID) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
      'Content-Type': 'application/octet-stream',
    };
    const response = await axios.get(
      `${this.getBaseURLMyEpik()}${apiVersion}/boxes/pcap/${boxId}/file/${callID}`,
      {
        responseType: 'arraybuffer',
        headers,
      },
    );
    return response;
  }

  async updateAdvanceModemConfigurations(boxId, payload) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.patch(
      `${this.getBaseURL()}${apiVersion}/obis/${boxId}/advancedmodemconfig`,
      payload,
      {
        headers,
      },
    );
    return data || {};
  }

  async getEpikBoxesGeoLocation(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data, status } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxId}/getGPS`,
      {
        headers,
      },
    );
    return { ...data, status } || {};
  }

  async triggerConnectivityStats(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${unifiedBaseURL()}${apiVersion}/boxes/${boxId}/refreshnetworkinfo`,
      {
        headers,
      },
    );
    return data;
  }

  async exportBoxNotes(boxID, queryFilter) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const queryParams = JSON.stringify(queryFilter);
    const { data } = await axios.get(
      `${myEpikBaseURL}${apiVersion}/reports/${boxID}/exportnotes?queryFilter=${queryParams}`,
      {
        headers,
        responseType: 'blob',
      },
    );

    if (queryFilter?.fileType === 'xlsx') {
      const file = new Blob([data], { type: 'text/csv' });
      const fileURL = URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = fileURL;
      const fileType = 'csv';
      const fileName = `BoxNotes_${queryFilter.serialNumber}.${fileType}`;
      a.download = fileName;
      a.click();
    } else {
      const fileType = queryFilter?.fileType || 'pdf';
      const fileName = `BoxNotes_${queryFilter.serialNumber}.${fileType}`;
      download(data, fileName, 'application/pdf');
    }

    return data;
  }

  async setMaintenanceNoteSeen(activeNotificationsIds) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/releaseNotes/seen`,
      { notifications: activeNotificationsIds },
      {
        headers,
      },
    );
    return data;
  }

  async boxActiveSimStats(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data, status } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxId}/activesimstats`,
      {
        headers,
      },
    );
    return { ...data, status } || {};
  }

  async addNewMacAddress(macAddress, isBoxTab) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${unifiedBaseURL()}${apiVersion}/obis/addmacaddress`,
      { macAddress, ...isBoxTab },
      {
        headers,
      },
    );
    return data;
  }

  async sendFA(params, isBoxTab) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      // `http://localhost:3002/api/v2/boxes/${params.boxId}/send2FA`, { data: params, boxId: params.boxId, isBoxTab },
      `${unifiedBaseURL()}${apiVersion}/boxes/${params.boxId}/send2FA`, { data: params, boxId: params.boxId, isBoxTab },
      {
        headers,
      },
    );
    return data;
  }

  async authenticate2FA(params) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      // `http://localhost:3002/api/v2/boxes/${params.boxId}/authenticate/${params.userId}`, { data: params },
      `${unifiedBaseURL()}${apiVersion}/boxes/${params.boxId}/authenticate/${params.userId}`, { data: params },
      {
        headers,
      },
    );
    return data;
  }

  async end2FASession(params) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${unifiedBaseURL()}${apiVersion}/boxes/${params.boxId}/end2FASession/${params.userId}`,
      { data: params },
      {
        headers,
      },
    );
    return data;
  }
  async sendBoxTone(vpnAddress) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${unifiedBaseURL()}${apiVersion}/boxes/${vpnAddress}/boxTone`,
      {
        headers,
      },
    );
    return data;
  }


  async fetchAndAssignUsbs(isBoxTab, boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${unifiedBaseURL()}${apiVersion}/boxes/${boxId}/createOob`, { isBoxTab, boxId },
      {
        headers,
      },
    );
    return data;
  }

  async fetchTtyData(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${unifiedBaseURL()}${apiVersion}/oob/tty/${boxId}`, {
      headers,
    });
    return data;
  }
  
  async fetchAvailableOobBTNs(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${unifiedBaseURL()}${apiVersion}/oob/${boxId}/device-btn-inventory`, {
      headers,
    });
    return data;
  }

  async postTtyData(isBoxTab, boxId, body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(`${unifiedBaseURL()}${apiVersion}/oob/tty-save/${boxId}`, {isBoxTab, boxId: boxId, ...body}, {
      headers,
    });
    return data;
  }

  async downloadTtyProfile(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${unifiedBaseURL()}${apiVersion}/oob/download/vpn/${boxId}`, {
      headers,
    });
    return data;
  }

  async removeOob(isBoxTab, boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${unifiedBaseURL()}${apiVersion}/boxes/${boxId}/removeOob`, { isBoxTab, boxId },
      {
        headers,
      },
    );
    return data;
  }
  
  async createSshUserProfile(isBoxTab, boxId, payload) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${unifiedBaseURL()}${apiVersion}/oob/${boxId}/createSshUser`, { isBoxTab, boxId, payload },
      {
        headers,
      },
    );
    return data;
  }
  
  async manageOpenVpnProfile(isBoxTab, boxId, ttyToggle) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${unifiedBaseURL()}${apiVersion}/oob/${boxId}/openVpnProfile`, { isBoxTab, boxId, ttyToggle },
      {
        headers,
      },
    );
    return data;
  }

  async updateAssignedUsbsName(boxId, params, isBoxTab) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${unifiedBaseURL()}${apiVersion}/boxes/${boxId}/updateAssignedUsbs`, { boxId, data: { oobList: params }, isBoxTab },
      {
        headers,
      },
    );
    return data;
  }

  async getDataOnBoxLoad(boxID) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${unifiedBaseURL()}${apiVersion}/boxes/load/${boxID}`,
      {
        headers,
      },
    );
    return data;
  }

  async getIsBoxOnline(vpnAddress) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${unifiedBaseURL()}${apiVersion}/boxes/alive/${vpnAddress}`,
      {
        headers,
      },
    );
    return data;
  }

  async latestMaintenanceNote() {
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/releaseNotes/maintenance/latest`);
    return data;
  }

  async addOobCategory(boxId, params, isBoxTab) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${unifiedBaseURL()}${apiVersion}/boxes/${boxId}/addOobCategory`, { boxId, params, isBoxTab },
      {
        headers,
      },
    );
    return data;
  }

  async getOobCategoryList(boxId, company) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${unifiedBaseURL()}${apiVersion}/boxes/${boxId}/getOobCategory/${company}`,
      {
        headers,
      },
    );
    return data;
  }

  async updateEpisFirmware(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${unifiedBaseURL()}${apiVersion}/obis/${boxId}/updateEpiFirmware`,
      {
        headers,
      },
    );
    return data;
  }
  async updateAllEpisFirmware(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${unifiedBaseURL()}${apiVersion}/obis/${boxId}/updateEpiFirmware/all`,
      {
        headers,
      },
    );
    return data;
  }

  async updateEpisFirmwareManually(boxId, macAddress, isBoxTab) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${unifiedBaseURL()}${apiVersion}/obis/${boxId}/updateEpiFirmware/${macAddress}`,
      { boxId, isBoxTab },
      {
        headers,
      },
    );
    return data;
  }
  async updateVad(obiId, enable, noReboot) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${unifiedBaseURL()}${apiVersion}/obis/${obiId}/vad`,
      { enable, noReboot },
      {
        headers,
      },
    );
    return data;
  }

  async provisionNow(boxId, macAddress) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/obis/${boxId}/provisionnow/${macAddress}`,
      { boxId },
      { headers },
    );
    return data;
  }

  async ext_9override(boxId, extValue) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${unifiedBaseURL()}${apiVersion}/boxes/${boxId}/extOverride`, { extOverride: extValue },
      {
        headers,
      },
    );
    return data;
  }


  async getBoxVoltage(vpnAddress) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/get-sensors-data/${vpnAddress}`,
      { headers },
    );
    return data;
  }


  async fetchNetworkInfo(vpnAddress) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${vpnAddress}/fetchNetworkInfo`,
      { headers },
    );
    return data;
  }

  async refreshDhcp(vpnAddress,body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${this.getBaseURL()}${apiVersion}/boxes/${vpnAddress}/refreshDhcp`,
      body,
      { headers },
    );
    return data;
  }

  async enableDisableEth3(boxId, vpnAddress, eth3Value, isBoxTab) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${unifiedBaseURL()}${apiVersion}/boxes/${vpnAddress}/disableEth3`,
      { eth3Value, boxId, isBoxTab },
      { headers },
    );
    return data;
  }

  async enableDisableEpikUpdates(status, boxId, isBoxTab) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${unifiedBaseURL()}${apiVersion}/boxes/${boxId}/epik-updates`,
      { boxId, isBoxTab, status },
      {
        headers,
      },
    );
    return data;
  }

  async fetchEpikUpdatesStatus(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${unifiedBaseURL()}${apiVersion}/boxes/${boxId}/epik-updates`,
      {
        headers,
      },
    );
    return data;
  }
  async setEpiTimezone(vpnAddress, epiTimezone) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${unifiedBaseURL()}${apiVersion}/boxes/${vpnAddress}/epiTimezone`,
      { epiTimezone },
      {
        headers,
      },
    );
    return data;
  }

  async updateDbcaAlert(boxId, dbcaValue, isBoxTab) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${unifiedBaseURL()}${apiVersion}/boxes/${boxId}/update-dbca-alerts`,
      { dbcaValue, isBoxTab, boxId },
      {
        headers,
      },
    );
    return data;
  }

  async orderNewBTNs(boxId, btnCount, isBoxTab) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${unifiedBaseURL()}${apiVersion}/oob/${boxId}/orderbtn`, { isBoxTab, boxId, btnCount},
      {
        headers,
      },
    );
    return data;
  }

  async startPcap(deviceIP, epiIP) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${unifiedBaseURL()}${apiVersion}/boxes/${deviceIP}/${epiIP}/startpcap`,
      {
        headers,
      },
    );

    return data;
  }
  async stopPcap(deviceIP, epiIP) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${unifiedBaseURL()}${apiVersion}/boxes/${deviceIP}/${epiIP}/stoppcap`,
      {
        headers,
      },
    );

    return data;
  }

  async downloadPcap(deviceIP, epiIP, serialNum) {
    const EPIIP = `172.16.16.25${epiIP}`;
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };

    try {
      const response = await axios.get(
        `${unifiedBaseURL()}${apiVersion}/boxes/${deviceIP}/${epiIP}/${serialNum}/downloadpcap`,
        {
          headers,
          responseType: 'blob',
        }
      );
      if (response.data instanceof Blob) {
        const fileName = `${serialNum}_${EPIIP}_${new Date().toISOString().replace(/:/g, '-')}.pcap`;
        return { blob: response.data, fileName };
      }
      else {
        // alert("Invalid file format received from the server.");
        return { blob: null, fileName: null };
      }
    } catch (error) {
      // alert("Failed to download the file. Please check the device or try again.");
      return { blob: null, fileName: null };
    }
  }
  async GeocodeRequestApi(addressData) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.post(
      `${unifiedBaseURL()}${apiVersion}/boxes/geocode-request`, { addressData},
      {
        headers,
      },
    );
    return data;
  }
  async checkSameUserkLockStatus(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${unifiedBaseURL()}${apiVersion}/boxes/${boxId}/checkLockStatus`,
      {
        headers,
      },
    );
    return data;
  }
   async getOobmBox() {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${unifiedBaseURL()}${apiVersion}/oobAssignment/getAllOobm`,
      {
        headers,
      },
    );
    return data;
  }
  async getLastDcRegistration(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${unifiedBaseURL()}${apiVersion}/boxes/getLastDcRegistration/${boxId}`,
      {
        headers,
      },
    );
    return data;
  }
  async getSalveboxOob(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxId}/oobslist`,
      {
        headers,
      },
    );
    return data;
  }
  async getEpikBoxById(
    boxId
  ) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(
      `${this.getBaseURL()}${apiVersion}/boxes/getBoxDetailById/${boxId}`,
      {
        headers,
      },
    );
    return data;
    return data || {};
  }
  async updateDeviceFeatures(boxId, body) {
    if (!boxId) throw new Error("boxId is required");
    const headers = { Authorization: `Bearer ${this.api.token}` };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/${boxId}/deviceFeature`,
      body,
      { headers }
    );
    return data || {};
  }

async updateDeviceFeature(boxId, updateDeviceFeature, toggle) {
  const headers = { Authorization: `Bearer ${this.api.token}` };
  const body = { [updateDeviceFeature]: toggle };
  const { data } = await axios.put(
    `${this.getBaseURL()}${apiVersion}/boxes/${boxId}/deviceFeature`,
    body,
    { headers }
  );
  return data || {};
}

  async updatePortFeature(obiId, boxId, portNumber,deviceId, updateData) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const body = {
      obiId,
      boxId,
      portNumber,
      deviceId,
      updateData,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/obis/${obiId}/callPort/feature`,
      body,
      { headers }
    );

    return data || {};
  }
  async bulkUpdateCallFeaturePorts(boxId, selectedPorts, sourcePortData) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const body = {
      selectedPorts, sourcePortData
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/obis/${boxId}/bulkUpdateCallFeaturePorts`,
      body,
      { headers }
    );
    return data || {};
  }
  async updateFailoverOptions(boxId, body) {
    const url = `${this.getBaseURL()}${apiVersion}/boxes/${encodeURIComponent(boxId)}/updateFailoverOptions`;
    try {
      const { data } = await axios.put(
        url,
        body,
        {
          headers: {
            Authorization: `Bearer ${this.api.token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return data;
    } catch (err) {
      const msg = err.response?.data.ErrorMessage ?err.response?.data.ErrorMessage  :  "Request failed";
      throw msg;
    }
  }
  async getFailoverOptions(boxId) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${this.getBaseURL()}${apiVersion}/boxes/${boxId}/getFailoverOptions`, {
      headers,
    });
    return data;
  }
  async getLowMtu(bid) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${unifiedBaseURL()}${apiVersion}/boxes/lowmtu/${bid}`, {
      headers,
    });
    return data;
  }
  async updateLowMtu(bid,body) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.put(
      `${this.getBaseURL()}${apiVersion}/boxes/lowmtu/${bid}`,
      body,
      {
        headers,
      },
    );
    return data;
  }
  async getModemverbose(vpnAddress) {
    const headers = {
      Authorization: `Bearer ${this.api.token}`,
    };
    const { data } = await axios.get(`${unifiedBaseURL()}${apiVersion}/boxes/modemverbose/${vpnAddress}`, {
      headers,
    });
    return data;
  }
};
export default BoxService;
